import React, { Component } from 'react'
import $ from 'jquery'

import { compose } from 'redux';
import { connect } from 'react-redux';

import {
    addModal,
    popModal
} from '../../../actions/appAction';

import {
    translate
} from 'react-switch-lang'

export class DeclineTaskModal extends Component {

    constructor(){
        super();
        this.state = {
            declineReason : "",
            showOtherInput : false,
            isReasonEmpty : false,
            modalZ : 1050
        }
    }

    componentDidMount(){
       
        const { isOpened } = this.props;
        
        if(isOpened){
            $('#declineTaskModal').modal({backdrop:'static', keyboard:false});
            $('#declineTaskModal .modal-dialog').attr('class','modal-dialog modal-dialog-centered slideInDown animated')
            $('#declineTaskModal').modal('show');
            this.props.addModal('decline-task-modal')
            $('.modal-backdrop').eq($('.modal-backdrop').length-1).addClass("dt-bd");
        }

    }

    componentDidUpdate(prevProps){
        if(prevProps.modalInstances!==this.props.modalInstances){
            let modalInstance = this.props.modalInstances.find( (data) => data.modal_class==="decline-task-modal");
            if(modalInstance!==undefined){
                $('.dt-bd').css('z-index',`${modalInstance.z_index-10}`)
                this.setState({
                    modalZ : modalInstance.z_index
                })
            }
        }
    }

    componentWillUnmount(){
        $('#declineTaskModal').modal('hide');
        this.props.popModal()
        $('body').removeClass('modal-open');
    }

    selectReason = (e) => {
        let text = $(e.target).parent('.checkbox-container').text();

        if(text==="Other"){
            this.setState({
                showOtherInput : true,
                declineReason : ""
            })
        }else{
            this.setState({
                declineReason : text,
                showOtherInput : false,
                isReasonEmpty : false
            })
        } 
    }

    onInputChange = (e) => {

        if(e.target.value.trim()!==""){
            this.setState({
                isReasonEmpty : false
            })
        }

        this.setState({
            declineReason : e.target.value
        })
    }

    declineTask = () => {

        const { declineReason } = this.state;

        if(declineReason===""){
            this.setState({
                isReasonEmpty: true
            })
        }else{
            this.props.declineTask({
                declineReason : declineReason
            })
        }

    }

    render(){
        const { modalZ, showOtherInput, isReasonEmpty } = this.state;
        
        const { isMobileView } = this.props;

        let modalDialogClass = isMobileView ? "mobile-modal" : ""

        const { t , currentLanguage } = this.props;

        return (
            <div style={{ zIndex : `${modalZ}` }} className={`${modalDialogClass} decline-task-modal modal fade modal-opaque`} id="declineTaskModal" tabIndex="-1" role="dialog" aria-labelledby="helpTaskModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        {
                            isMobileView ?
                            <div className="mobile-custom-header modal-header">
                                <div className="row" style={{ width: "100%" }}>
                                    <div className="col" style={{ textAlign : "left" }}>
                                        <img style={{ display: "block", width: "150px" }} src={require('../../../images/tarjemle-logo.png')}/>
                                    </div>
                                    <div className="col" style={{ textAlign : "right", paddingRight : "0" }}>
                                        <button onClick={this.props.closeDeclineTaskModal} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span className="close-modal-btn" aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="custom-modal-header modal-header">
                                <button onClick={this.props.closeDeclineTaskModal} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span className="close-modal-btn" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        }
                      
                        <div className="modal-body">
                            <p className="text-header">{t('task_modal_decline_header')}</p>
                            <p className="align-left" style={{ fontWeight : "bold", marginLeft : "30px", marginTop : "50px" }}>{t('task_modal_decline_sub_header')}</p>
                            
                            <div className="form-group">
                                <ul className="reason-list align-left">
                                    <li>
                                        <label className="checkbox-container">{t('task_modal_decline_deadline_too_short')}
                                            <input name="reason" onClick={this.selectReason} className="reason" type="radio"/>
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="checkbox-container">{t('task_modal_decline_task_desc_too_short')}
                                            <input name="reason" onClick={this.selectReason} className="reason" type="radio"/>
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="checkbox-container">{t('task_modal_decline_too_busy')}
                                            <input name="reason" onClick={this.selectReason} className="reason" type="radio"/>
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="checkbox-container">{t('common_other')}
                                            <input name="reason" onClick={this.selectReason} className="reason" type="radio"/>
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                            <div className="form-group" style ={{ textAlign : "left", paddingLeft : "30px" }}>
                            { showOtherInput && <input style={{ width: "90%" }} onChange={this.onInputChange} id="other_reason" name="other_reason" style={{ width: "100%" }} className={`custom-input ${ isReasonEmpty ? "error-input" : ""}`} type="text" placeholder={t('common_write_reason')}/> }  
                            </div>
                            <div className="text-center">
                                <button onClick={this.declineTask} style={{ width: "100%" , border :"none", background : "#22C9C7", borderRadius : "8px", padding: "16px 20px", fontSize : "16px", fontWeight : "bold", textTransform : "uppercase", textAlign : "center", color : "#FAFAFA", marginTop : "30px" }}>{t('task_modal_decline_button')}</button>    
                            </div>                            
                        </div>
                    
                    </div>
                </div>
            </div>
            
        )

    }

}

const mapStateToProps = state => {
    return {
        modalInstances : state.app.modalInstances,
        isMobileView : state.app.isMobileView,
        currentLanguage : state.app.currentLanguage
    }
}

export default compose(
    translate,
    connect(mapStateToProps, { 
        addModal,
        popModal
    })
)(DeclineTaskModal)